import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { AppModule } from '@/store/modules/app'
import { getType } from '@/utils/cookies'

const urlWhite = ['manage/jump-checkout-counter']
const timeout = 60 * 1000
const hostname = window.location.hostname
const http = window.location.protocol
let url = ''
if (getType() === 'ant') {
  url = 'https://ant.lucky-money.in/api'
} else {
  url = 'https://api.zolopay.com/api'
}
const isant = getType() === 'ant' ? 'ant' : 'api'
const baseURL =
  hostname === 'localhost'
    ? `${url}`
    : http + `//${isant}` + hostname.substring(hostname.indexOf('.')) + '/api'

// UserModule.SetBaseUrl(baseURL)
const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  timeout: 60000
})

// Request interceptors
service.interceptors.request.use(
  async config => {
    // 设置token
    if (UserModule.token && getType() !== 'ant') {
      config.headers['Authorization'] = 'Token ' + UserModule.token
    } else if (UserModule.token && getType() === 'ant' && UserModule.antToken) {
      config.headers['Authorization'] = 'Token ' + UserModule.antToken
    } else {
      config.headers['Authorization'] = 'Token ' + UserModule.token
    }
    let newurl = ''
    if (getType() === 'ant') {
      newurl = 'https://ant.lucky-money.in/api'
    } else {
      newurl = 'https://api.zolopay.com/api'
    }
    const isnewant = getType() === 'ant' ? 'ant' : 'api'
    config.baseURL =
      hostname === 'localhost'
        ? `${newurl}`
        : http +
          `//${isnewant}` +
          hostname.substring(hostname.indexOf('.')) +
          '/api'
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  response => {
    if (
      response.status !== 200 &&
      response.status !== 201 &&
      response.status !== 202 &&
      response.status !== 204
    ) {
      Message({
        message: response.data.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (response.data.code === 401) {
        MessageBox.alert('Login has expired, please login again!', {
          showClose: false,
          confirmButtonText: 'yes',
          type: 'warning',
          callback: () => {
            UserModule.LogOut()
            location.reload()
          }
        })
      }
      return Promise.reject(new Error(response.data.message || 'Error'))
    } else {
      return response.data
    }
  },
  async error => {
    // if (error.config.timeout === timeout) {
    //   const config = error.config
    //   if (urlWhite.indexOf(config.url) !== -1) {
    //     return Promise.reject(error)
    //   }
    //   if (error.message.indexOf('timeout of') === 0) {
    //     axios(config)
    //   }
    // }

    const response = error.response
    if (response && response.data) {
      if (response.status === 405) {
        Message({
          message: 'Failed to fill in the audit content, operation failed!',
          type: 'warning',
          duration: 5 * 1000
        })
      } else {
        if (
          !(
            response.data.code === 400 &&
            response.data.message ===
              "{'description': [ErrorDetail(string='This field is required.', code='required')]}"
          )
        ) {
          // 开启状态。输入错误
          if (response.data.code === 10001) {
            if (AppModule.enterprise.google_auth_switch) {
              Message({
                message: 'Google verification code error！',
                type: 'error',
                duration: 5 * 1000
              })
            } else {
              Message({
                message: 'Google verification is enabled, please re-operate!！',
                type: 'warning',
                duration: 5 * 1000
              })
            }
          } else {
            if (response.data.message) {
              Message({
                message: response.data.message,
                type: 'error',
                duration: 5 * 1000
              })
            }
          }
        }
      }
    }
    if (
      response &&
      response.data.code === 401 &&
      response.config.url !== 'manage/login'
    ) {
      MessageBox.alert('Login has expired, please login again!', {
        showClose: false,
        confirmButtonText: 'yes',
        type: 'warning',
        callback: () => {
          UserModule.LogOut()
          location.reload()
        }
      })
    }
    if ((response && response.data.code === 500) || response?.status === 500) {
      Message({
        message: 'The server went haywire... Please contact the administrator',
        type: 'error',
        duration: 5 * 1000
      })
    }
    if ((response && response.data.code === 504) || response?.status === 504) {
      Message({
        message: 'Request timed out!',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
